import { render, staticRenderFns } from "./MediaImageTexteSurImage.vue?vue&type=template&id=4cc812ae&scoped=true"
import script from "./MediaImageTexteSurImage.vue?vue&type=script&lang=js"
export * from "./MediaImageTexteSurImage.vue?vue&type=script&lang=js"
import style0 from "./MediaImageTexteSurImage.vue?vue&type=style&index=0&id=4cc812ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc812ae",
  null
  
)

export default component.exports